import { recordMonitoringMetricSample } from "@repo/monitoring";
import { amcPdpMonitoringSchema } from "./amcPdpMonitoringSchema";

export const COMPONENT_CTA_FUNCTIONING_METRIC_ID = "business.component_cta_functioning";

export function recordAmcPdpCtaMetric(
  stepName: string,
  options: {
    componentName: string;
    ctaName?: string;
    success: boolean;
    extra?: Record<string, string | number | boolean | null>;
  }
): boolean {
  return recordMonitoringMetricSample(amcPdpMonitoringSchema, COMPONENT_CTA_FUNCTIONING_METRIC_ID, {
    value: 1,
    unit: "count",
    success: options.success,
    extra: {
      component_name: options.componentName,
      cta_name: options.ctaName ?? "",
      step_name: stepName,
      ...options.extra,
    },
  });
}
